import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPartyHorn } from '@fortawesome/pro-regular-svg-icons/faPartyHorn';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import Cookies from 'universal-cookie';

import { Button, ButtonSize, ButtonType } from '../../components';
import { useModal } from '../modalContext';
import { Storage } from '../../constants';

export const BookingAgencySuccessModalContent = (): JSX.Element => {
  const cookies = new Cookies();
  const modal = useModal();
  const { t } = useTranslation();

  const closeModal = (): void => {
    modal?.setModalName(undefined);
  }

  useEffect(() => {
    cookies.remove(Storage.AGENCY_BOOKING_SUCCESS, { path: '/' });
  }, []);

  return (
    <>
      <Button aria-label='Close modal' className='h-8 float-right mr-2' onClick={closeModal}>
        <FontAwesomeIcon icon={faXmark} />
      </Button>
      <div className='flex flex-col items-center my-8'>
        <FontAwesomeIcon size='4x' icon={faPartyHorn} className='text-emerald' />
      </div>
      <div className='float-left font-bold text-lg mb-5'>{t('modals.bookingAgencySuccess.title')}</div>
      {t('modals.bookingAgencySuccess.body')}
      <div className='flex flex-col items-center mt-8'>
        <Button
          onClick={closeModal}
          buttonType={ButtonType.primary}
          buttonSize={ButtonSize.medium}
          className='mx-auto mb-4 rounded-full'
        >
          {t('common.ok')}
        </Button>
      </div>
    </>
  );
};
